const authInitialState = {
  user: [],
  MenuList: [],
  permissions: [],
  // ── Distributor scope (added for permission system §1) ──
  companyType: null, // 'restaurant' | 'wholesale' | 'retailer' | 'distributor'
  isSuperAdmin: false,
  isCompanyOwner: false,
  parentCompanyId: null,
  error: null
};

const AuthReducer = (state = authInitialState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, user: action.payload, error: null };
    case 'LOGIN_FAILURE':
      return { ...state, error: action.payload, user: null };
    case 'GET_MENU_LIST_SUCCESS':
      return { ...state, MenuList: action.payload, error: null };
    case 'GET_MENU_LIST_FAILURE':
      return { ...state, error: action.payload, MenuList: null };

    case 'GET_PERMISSIONS_SUCCESS':
      return { ...state, permissions: action.payload, error: null };
    case 'GET_PERMISSIONS_FAILURE':
      return { ...state, error: action.payload, permissions: [] };

    // GET /api/auth/me/permissions — full scope payload
    // (permission_codes, company_type, is_super_admin, is_company_owner, parent_company_id)
    case 'GET_MY_SCOPE_SUCCESS':
      return {
        ...state,
        permissions: action.payload.permission_codes || [],
        companyType: action.payload.company_type ?? null,
        isSuperAdmin: !!action.payload.is_super_admin,
        isCompanyOwner: !!action.payload.is_company_owner,
        parentCompanyId: action.payload.parent_company_id ?? null,
        error: null
      };
    case 'GET_MY_SCOPE_FAILURE':
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default AuthReducer;
